var map = {
	"./Bitdepth.gif": "0fc9",
	"./Closed.gif": "e746",
	"./Closed_with_mic.gif": "8a42",
	"./Heaving.gif": "33f7",
	"./Listening.gif": "e906",
	"./Presets.gif": "d3e5",
	"./Thinking.gif": "5378",
	"./User_input.gif": "99ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de98";